import styles from "../articles/ArticlesPage.module.scss";
import { strings } from "intl/fa";
import { Section } from "../TutorialsList";
import { videosData } from "../tutorials";
import { TutorialItem } from "../TutorialItem";

function VideosPage() {
  return (
    <div className={styles.Content}>
      <Section primaryText={strings.tutorials.videos_list}>
        <div className={styles.AllTutorialsWrapper}>
          {videosData.map((tutorial) => (
            <TutorialItem tutorial={tutorial} key={tutorial.name} />
          ))}
        </div>
      </Section>
    </div>
  );
}

export default VideosPage;
